export default {}



// WEBPACK FOOTER //
// ./src/app/patient/store.js